/**
 * Injects a JSON-LD structured data script tag into <head>.
 * Used for SEO (e.g. MusicGroup schema on the homepage).
 * Removes the script on unmount to avoid duplicates across routes.
 */
import { useEffect } from "react";

interface JsonLdData {
  [key: string]: unknown;
}

const useJsonLd = (data: JsonLdData) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);
};

export default useJsonLd;
